function SaveManager() {
	document.body.insertBefore(
		this.elem = UI.div('saveManager'),
		document.body.firstChild
	);
	this.saveQue = [];
    this.undoQue = [];
	this.markers = [];
}

SaveManager.prototype = {
	queue: function (obj, saveCall) {
		saveCall = saveCall || 'saveNow';
		var queueObj = {a: obj, b: saveCall};
		if (this.saveQue.length === 0) {
			this.saveQue.push(queueObj);
			obj[saveCall]();
		} else {
			var i = this.saveQue.lastIndexOf(queueObj);
			if (i > 0) this.saveQue.splice(i, 1);
			this.saveQue.push(queueObj);
		}
		this.refresh();
	},
	nudge: function () {
		this.undoQue.push(this.saveQue.shift());
		if (this.saveQue.length) this.saveQue[0].a[this.saveQue[0].b]();
		this.refresh();
	},
	refresh: function () {
		var n = this.saveQue.length;
		var d;
		for (var i = 0; i < this.markers.length; i++) {
			this.markers[i].style.display = (i < n) ? 'inline-block' : 'none';
		}
		while (this.markers.length < n) {
			d = UI.div('saveQueMarker');
			this.markers.push(d);
			this.elem.appendChild(d);
		}
	}
};